import React from 'react';
import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import NumberFormat from 'react-number-format';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

//////////////////
// Builder Related

export const NumberFormatComponent = React.forwardRef(
  function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        isNumericString
      />
    );
  }
);

export const NumberFormatComponentCustom = React.forwardRef(
  function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        isNumericString
      />
    );
  }
);

export const Header = styled('div')(({ theme }) => ({
  color: theme.palette.text.t100,
  fontWeight: 'bold',
  fontSize: theme.typography.pxToRem(40),
  textAlign: 'left',
}));

export const InputHeader = styled('div')(({ theme }) => ({
  color: theme.palette.text.t100,
  fontSize: theme.typography.pxToRem(14),
  fontWeight: 'bold',
  margin: '10px 0px',
  display: 'flex',
  justifyContent: 'space-between',
}));

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(
  ({ theme }) => ({
    '& .Mui-selected': {
      backgroundColor: '#0A7BB8 !important',
      color: 'white !important',
    },
  })
);

export const MediaTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.text.t100,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.text.t100,
    color: '#FFFFFF',
  },
}));

export const StyledChip = styled(Chip)(({ theme }) => ({
  margin: 2,
  marginRight: 10,
  maxWidth: 140,
  color: theme.palette.primary.t100,
  border: theme.palette.primary.t100,
  background: theme.palette.primary.t20,
  borderRadius: 6,
  fontSize: 12,
}));

export const PlotTittle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));

/////////////////
// Graphs Related

export const GraphHeader = styled('div')(({ theme }) => ({
  color: theme.palette.text.t100,
  fontWeight: 'bold',
  fontSize: theme.typography.pxToRem(26),
  padding: '10px',
}));

export const ChipsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  marginLeft: '10px',
}));

export const GraphChip = styled(Chip)(({ theme }) => ({
  margin: '0px 2px',
  borderRadius: '4px',
  color: theme.palette.text.t70,
  border: `1px solid ${theme.palette.text.t50}`,
  backgroundColor: 'white',
}));

const SI_SYMBOL = ['', 'k', 'M', 'B', 'T', 'P', 'E'];
export const convertTOKM = (num, idx) => {
  if (idx === 0 || typeof num === 'string') {
    return num;
  } else {
    if (idx === 3 || idx === 4 || (idx >= 6 && idx <= 8)) {
      return `${(num * 100).toLocaleString(undefined, {
        maximumFractionDigits: 2,
      })}%`;
    } else {
      const noprefix = [2, 3, 4, 5, 6, 7, 8, 11];
      const tier = (Math.log10(Math.abs(num)) / 3) | 0;

      // if zero, we don't need a suffix
      if (tier === 0)
        return `${noprefix.includes(idx) ? '' : '$'}${num.toLocaleString(
          undefined,
          {
            maximumFractionDigits: 2,
          }
        )}`;
      // get suffix and determine scale
      const suffix = tier > 0 && tier < SI_SYMBOL.length ? SI_SYMBOL[tier] : '';
      const scale = Math.pow(10, tier * 3);
      // scale the number
      const scaled = num / scale;
      // format number and add suffix
      return `${noprefix.includes(idx) ? '' : '$'}${
        scaled.toFixed(1) + suffix
      }`;
    }
  }
};
